import React from "react";
import { Badge } from "../../../../shared/ui";

/** Status pill — the colour is the entity's own, tinted for the fill and the border. */
export const BadgeCell: React.FC<{ color: string; label: string }> = ({ color, label }) => (
  <Badge color={color} label={label} size="sm" />
);
